import React, { useState } from 'react';
import styles from './FilterBar.module.css';

interface FilterBarProps {
  gap?: 'sm' | 'lg';
  pushFirstChild?: boolean;
  compact?: boolean;
  className?: string;
  children: React.ReactNode;
}

const FilterBar: React.FC<FilterBarProps> = ({
  gap = 'lg',
  pushFirstChild = false,
  compact = false,
  className = '',
  children,
}) => {
  const [expanded, setExpanded] = useState(false);
  const childArray = React.Children.toArray(children);
  const leadingChild = pushFirstChild ? childArray[0] : null;
  const filterChildren = pushFirstChild ? childArray.slice(1) : childArray;
  const cls = [
    styles['filter-bar'],
    gap === 'sm' ? styles['gap-sm'] : styles['gap-lg'],
    pushFirstChild ? styles['push-first'] : '',
    compact ? styles.compact : '',
    expanded ? styles.expanded : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={cls}>
      {leadingChild ? <div className={styles.leading}>{leadingChild}</div> : null}
      <button
        type="button"
        className={styles['filter-toggle']}
        onClick={() => setExpanded((current) => !current)}
        aria-expanded={expanded}
      >
        <span className="material-symbols-outlined" aria-hidden="true">filter_list</span>
        {expanded ? 'Ocultar filtros' : 'Filtros'}
      </button>
      <div className={styles['filters-content']}>
        {filterChildren}
      </div>
    </div>
  );
};

export default FilterBar;
